const BaseUrl = () => {
  const hostname = window.location.hostname;

  // Determine if the environment is production
  const isProd =
    /^(\w+\.)?nomadcredit\.com$/.test(hostname) &&
    !hostname.startsWith("staging");

  // Construct the full API base URL
  return `https://${isProd ? "prod" : "stagingapi"}.nomadcredit.com`;
};

export const apiBaseUrl = BaseUrl();
